import { useState, useEffect } from "react";
import { Button } from "components/ui/button";
import { CategoryGridEditor } from "components/widgets/CategoryGridEditor";
import { widget_types } from "constants/widget-constant";
import { ShowCarouselForm } from "components/widgets/ShowCarouselForm";
import CarouselManager from "components/widgets/carousel/CarouselManager";

export const WidgetEditor = ({
    widget,
    onChange,
}: {
    widget: any;
    onChange: (w: any) => void;
}) => {
    const widgetType = widget?.widget_code;

    const [draftWidget, setDraftWidget] = useState(widget);
    const [widgetDraftData, setWidgetDraftData] = useState<any>([])

    useEffect(() => {
        setDraftWidget(widget);
    }, [widget]);

    const handleSaveWidget = () => {
        onChange(widgetDraftData)
    };

    console.log('setWidgetDraftData .....', widgetDraftData)
    return (
        <div className="space-y-2">
            {/* EDITOR */}
            {widgetType === widget_types?.Category_Grid ? (
                <CategoryGridEditor
                    widget={draftWidget}
                    setWidgetDraftData={setWidgetDraftData}
                />
            ) :
                widgetType === widget_types?.Show_Carousel ? (
                    <div> Inside Show Carousel</div>
                ) :
                widgetType === widget_types?.HomePage_Banner_Carousel ? (
                    <CarouselManager   widget={draftWidget}
                    setWidgetDraftData={setWidgetDraftData} />
                ) :
                    (
                        <p className="text-sm text-gray-500">
                            No editor available for this widget
                        </p>
                    )}

            {/* SAVE BUTTON */}
            <div className="flex justify-end border-t pt-4">
                <Button
                    color="blue"
                    type="button"
                    onClick={handleSaveWidget}
                >
                    Save Widget Data
                </Button>
            </div>
        </div>
    );
};
